import { authHeader } from '../utils';

export const licenseService = {
  create,
  update,
  getAll,
  getAllForUser,
  getAllForAdmin,
  exportValidatedLicense,
};

function create(license) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(license),
  };

  return fetch('/api/licenserequests', requestOptions).then(handleResponse);
}

function update(licenseId, status, currentPage, filterStatus) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: status,
  };
  return fetch(
    '/api/licenserequests/' + licenseId + '/status',
    requestOptions
  ).then(response => {
    if (!response.ok) {
      return Promise.reject(response.status);
    } else {
      return getAll(currentPage, filterStatus);
    }
  });
}

function getAll(pageNumber, status) {
  let statusParam;
  if (status !== 'undefined') {
    switch (status) {
      case 0:
        statusParam = 'ALL';
        break;
      case 1:
        statusParam = 'EXPIRED';
        break;
      case 2:
        statusParam = 'REFUSED';
        break;
      case 3:
        statusParam = 'VALIDATED';
        break;
      case 4:
        statusParam = 'WAITING_FOR_VALIDATION';
        break;
      default:
        statusParam = 'WAITING_FOR_VALIDATION';
        break;
    }
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    '/api/licenserequests?status=' + statusParam + '&page=' + pageNumber,
    requestOptions
  ).then(response => handlePaginatedResponse(response, pageNumber));
}

function getAllForUser(userId, pageNumber) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    '/api/users/' + userId + '/licenses?page=' + pageNumber,
    requestOptions
  ).then(response => handlePaginatedResponse(response, pageNumber));
}

function getAllForAdmin(pageNumber) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch('/api/licenses?page=' + pageNumber, requestOptions).then(
    response => handlePaginatedResponse(response, pageNumber)
  );
}

function exportValidatedLicense() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch('/api/licenses/file', requestOptions).then(response =>
    handleFileResponse(response)
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return response.json();
  }
}

function handlePaginatedResponse(response, pageNumber) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return response
      .json()
      .then(json => ({
        headers: response.headers,
        json,
      }))
      .then(({ headers, json }) => {
        let result = {
          nbPages: headers.get('x-orange-total-pages'),
          nbLicenses: headers.get('x-orange-total-items'),
          licenses: json,
          currentPage: pageNumber,
        };
        return result;
      });
  }
}

function handleFileResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return response.blob();
  }
}



// WEBPACK FOOTER //
// ./src/services/license.service.js